export const isCollect = state => state.isCollect


// WEBPACK FOOTER //
// ./src/stroe/getters.js